export const splitArray = (candid: any[]) => {
  let oddOnes: any[] = [],
    evenOnes: any[] = [];
  for (let i = 0; i < candid.length; i++)
    (i % 2 === 0 ? evenOnes : oddOnes).push(candid[i]);
  return { even: evenOnes, odd: oddOnes };
};
